import { render, staticRenderFns } from "./PT505GTMAddToWishlist.vue?vue&type=template&id=2310e962&"
import script from "./PT505GTMAddToWishlist.vue?vue&type=script&lang=js&"
export * from "./PT505GTMAddToWishlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports